"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = require("../../../utils/index");
var _Systems = _interopRequireDefault(require("../systems/Systems"));
var _utils = require("../utils");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
class Invests extends _Systems.default {
  get id() {
    return this.opts.id || 'tropical-invests';
  }
  source() {
    const request = this.account.api().endpoint('tropicalcyclones').action("search" /* ApiAction.SEARCH */).limit(50).filter('invests');
    const properties = {
      id: 'id',
      category: 'details.stormCat',
      timestamp: 'timestamp',
      points: ['track', 'forecast']
    };
    return {
      type: 'vector',
      data: {
        service: request,
        properties,
        formatter: data => (0, _utils.formatStormData)(data)
      },
      style: {
        marker: data => (0, _utils.getStormMarkerConfig)(data),
        polygon: data => ({
          fill: {
            color: '#ffffff',
            opacity: 0.7
          }
        }),
        polyline: data => {
          const type = (0, _index.get)(data, 'details.stormCat');
          return {
            stroke: {
              color: (0, _utils.color)(type),
              width: 3
            }
          };
        }
      },
      animation: {
        enabled: true
      }
    };
  }
  controls() {
    return {
      value: this.id,
      title: 'Invests'
    };
  }
}
var _default = exports.default = Invests;
module.exports = exports.default;